import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { EN } from "./en";

const LangContext = createContext(null);
const STORAGE_KEY = "klus_lang";

function detectDefault() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === "ro" || saved === "en") return saved;
  const nav = (navigator.language || navigator.userLanguage || "").toLowerCase();
  // Default is Romanian; only English browsers auto-start in English.
  return nav.startsWith("en") ? "en" : "ro";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "ro"), []);

  // Romanian is the source language; English is looked up, falling back to the source string.
  const t = useCallback(
    (s) => {
      if (lang === "ro") return s;
      return (EN && EN[s] !== undefined ? EN[s] : s);
    },
    [lang]
  );

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useT() {
  const ctx = useContext(LangContext);
  if (!ctx) return { lang: "ro", setLang: () => {}, t: (s) => s };
  return ctx;
}
